// Generated by purs version 0.14.5
"use strict";
var Data_Eq = require("../Data.Eq/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Nullable = require("../Data.Nullable/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Variant_Internal = require("../Data.Variant.Internal/index.js");
var Kishimen = require("../Kishimen/index.js");
var TofuJSON = require("../TofuJSON/index.js");
var Types_ClassificationGroup = require("../Types.ClassificationGroup/index.js");
var Types_Component = require("../Types.Component/index.js");
var Types_Element = require("../Types.Element/index.js");
var Types_Newtypes = require("../Types.Newtypes/index.js");
var Types_Project = require("../Types.Project/index.js");
var Types_Unit = require("../Types.Unit/index.js");
var WasmResourcesByComponent = function (x) {
    return x;
};
var GroupBySubproject = (function () {
    function GroupBySubproject() {

    };
    GroupBySubproject.value = new GroupBySubproject();
    return GroupBySubproject;
})();
var GroupByGroup = (function () {
    function GroupByGroup() {

    };
    GroupByGroup.value = new GroupByGroup();
    return GroupByGroup;
})();
var GroupByCostGroup = (function () {
    function GroupByCostGroup() {

    };
    GroupByCostGroup.value = new GroupByCostGroup();
    return GroupByCostGroup;
})();
var GroupByClassification = (function () {
    function GroupByClassification() {

    };
    GroupByClassification.value = new GroupByClassification();
    return GroupByClassification;
})();
var GroupByLocation = (function () {
    function GroupByLocation() {

    };
    GroupByLocation.value = new GroupByLocation();
    return GroupByLocation;
})();
var ClipboardEmpty = (function () {
    function ClipboardEmpty() {

    };
    ClipboardEmpty.value = new ClipboardEmpty();
    return ClipboardEmpty;
})();
var ClipboardComponentView = (function () {
    function ClipboardComponentView(value0) {
        this.value0 = value0;
    };
    ClipboardComponentView.create = function (value0) {
        return new ClipboardComponentView(value0);
    };
    return ClipboardComponentView;
})();
var ClipboardElementView = (function () {
    function ClipboardElementView(value0) {
        this.value0 = value0;
    };
    ClipboardElementView.create = function (value0) {
        return new ClipboardElementView(value0);
    };
    return ClipboardElementView;
})();
var newtypeWasmResourcesByComponent = {
    Coercible0: function () {
        return undefined;
    }
};
var jsonWasmResourcesByComponent = TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "component";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "amount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "checked";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "componentType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupDescription";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "flagged";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subProjectCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subProjectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subProjectName";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "amount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "checked";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "componentType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupDescription";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "flagged";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subProjectCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subProjectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONSubprojectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subProjectName";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resources";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "component";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "amount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "checked";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "componentType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupDescription";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "flagged";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subProjectCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subProjectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subProjectName";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "amount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "checked";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "componentType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupDescription";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "flagged";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subProjectCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subProjectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONSubprojectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subProjectName";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resources";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.nilWriteForeignFields)()()())()()());
var genericECGroupByProperty = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return GroupBySubproject.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return GroupByGroup.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return GroupByCostGroup.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return GroupByClassification.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
            return GroupByLocation.value;
        };
        throw new Error("Failed pattern match at Types.ComponentsView (line 33, column 1 - line 33, column 72): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof GroupBySubproject) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof GroupByGroup) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof GroupByCostGroup) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof GroupByClassification) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof GroupByLocation) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))));
        };
        throw new Error("Failed pattern match at Types.ComponentsView (line 33, column 1 - line 33, column 72): " + [ x.constructor.name ]);
    }
};
var tofuJSONECGroupByProperty = {
    writeImpl: TofuJSON.writeGenericSum()(TofuJSON.readVariantCons({
        reflectSymbol: function () {
            return "GroupByClassification";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
        reflectSymbol: function () {
            return "GroupByCostGroup";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
        reflectSymbol: function () {
            return "GroupByGroup";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
        reflectSymbol: function () {
            return "GroupByLocation";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
        reflectSymbol: function () {
            return "GroupBySubproject";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantNil))))))(TofuJSON.consWriteForeignVariant({
        reflectSymbol: function () {
            return "GroupByClassification";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
        reflectSymbol: function () {
            return "GroupByCostGroup";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
        reflectSymbol: function () {
            return "GroupByGroup";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
        reflectSymbol: function () {
            return "GroupByLocation";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
        reflectSymbol: function () {
            return "GroupBySubproject";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.nilWriteForeignVariant))))))(genericECGroupByProperty)(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
        reflectSymbol: function () {
            return "GroupBySubproject";
        }
    })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
        reflectSymbol: function () {
            return "GroupByGroup";
        }
    })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
        reflectSymbol: function () {
            return "GroupByCostGroup";
        }
    })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
        reflectSymbol: function () {
            return "GroupByClassification";
        }
    })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantConstructor({
        reflectSymbol: function () {
            return "GroupByLocation";
        }
    })()(Kishimen.genericSumToVariantArgNoArguments))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupByClassification";
        }
    }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupByLocation";
        }
    })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupByCostGroup";
        }
    }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupByLocation";
        }
    }))({
        reflectSymbol: function () {
            return "GroupByClassification";
        }
    })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupByGroup";
        }
    }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupByLocation";
        }
    }))({
        reflectSymbol: function () {
            return "GroupByCostGroup";
        }
    }))({
        reflectSymbol: function () {
            return "GroupByClassification";
        }
    })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupBySubproject";
        }
    }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupByLocation";
        }
    }))({
        reflectSymbol: function () {
            return "GroupByGroup";
        }
    }))({
        reflectSymbol: function () {
            return "GroupByCostGroup";
        }
    }))({
        reflectSymbol: function () {
            return "GroupByClassification";
        }
    }))),
    readImpl: TofuJSON.readGenericSum(genericECGroupByProperty)(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
        reflectSymbol: function () {
            return "GroupBySubproject";
        }
    })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
        reflectSymbol: function () {
            return "GroupByGroup";
        }
    })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
        reflectSymbol: function () {
            return "GroupByCostGroup";
        }
    })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
        reflectSymbol: function () {
            return "GroupByClassification";
        }
    })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantConstructor({
        reflectSymbol: function () {
            return "GroupByLocation";
        }
    })()(Kishimen.genericSumToVariantArgNoArguments))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupByClassification";
        }
    }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupByLocation";
        }
    })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupByCostGroup";
        }
    }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupByLocation";
        }
    }))({
        reflectSymbol: function () {
            return "GroupByClassification";
        }
    })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupByGroup";
        }
    }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupByLocation";
        }
    }))({
        reflectSymbol: function () {
            return "GroupByCostGroup";
        }
    }))({
        reflectSymbol: function () {
            return "GroupByClassification";
        }
    })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupBySubproject";
        }
    }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
        reflectSymbol: function () {
            return "GroupByLocation";
        }
    }))({
        reflectSymbol: function () {
            return "GroupByGroup";
        }
    }))({
        reflectSymbol: function () {
            return "GroupByCostGroup";
        }
    }))({
        reflectSymbol: function () {
            return "GroupByClassification";
        }
    })))()(TofuJSON.readVariantCons({
        reflectSymbol: function () {
            return "GroupByClassification";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
        reflectSymbol: function () {
            return "GroupByCostGroup";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
        reflectSymbol: function () {
            return "GroupByGroup";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
        reflectSymbol: function () {
            return "GroupByLocation";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
        reflectSymbol: function () {
            return "GroupBySubproject";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantNil))))))(TofuJSON.consWriteForeignVariant({
        reflectSymbol: function () {
            return "GroupByClassification";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
        reflectSymbol: function () {
            return "GroupByCostGroup";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
        reflectSymbol: function () {
            return "GroupByGroup";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
        reflectSymbol: function () {
            return "GroupByLocation";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
        reflectSymbol: function () {
            return "GroupBySubproject";
        }
    })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.nilWriteForeignVariant))))))
};
var eqWasmResourcesByComponent = {
    eq: function (x) {
        return function (y) {
            return x.component.amount === y.component.amount && x.component.checked === y.component.checked && Data_Eq.eq(Data_Nullable.eqNullable(Data_Eq.eqString))(x.component.classCode)(y.component.classCode) && Data_Eq.eq(Data_Nullable.eqNullable(Data_Eq.eqString))(x.component.code)(y.component.code) && x.component.componentType === y.component.componentType && Data_Eq.eq(Data_Nullable.eqNullable(Data_Eq.eqString))(x.component.costGroupCode)(y.component.costGroupCode) && Data_Eq.eq(Data_Nullable.eqNullable(Data_Eq.eqString))(x.component.costGroupDescription)(y.component.costGroupDescription) && x.component.description === y.component.description && x.component.flagged === y.component.flagged && Data_Eq.eq(Data_Nullable.eqNullable(Types_ClassificationGroup.eqClassificationGroupCode))(x.component.group)(y.component.group) && Data_Eq.eq(Types_Component.eqComponentId)(x.component.id)(y.component.id) && x.component.memo === y.component.memo && Data_Eq.eq(Data_Nullable.eqNullable(Data_Eq.eqString))(x.component.subProjectCode)(y.component.subProjectCode) && Data_Eq.eq(Data_Nullable.eqNullable(Types_Project.eqSubprojectId))(x.component.subProjectId)(y.component.subProjectId) && Data_Eq.eq(Data_Nullable.eqNullable(Data_Eq.eqString))(x.component.subProjectName)(y.component.subProjectName) && Data_Eq.eq(Data_Nullable.eqNullable(Data_Eq.eqString))(x.component.unit)(y.component.unit) && Data_Eq.eq(Data_Eq.eqArray(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
                reflectSymbol: function () {
                    return "wastePercentage";
                }
            })(Data_Eq.eqNumber))()({
                reflectSymbol: function () {
                    return "vendorUnit";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                reflectSymbol: function () {
                    return "vendorCode";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                reflectSymbol: function () {
                    return "vendorBatchSize";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqNumber)))()({
                reflectSymbol: function () {
                    return "vendor";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                reflectSymbol: function () {
                    return "validDate";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                reflectSymbol: function () {
                    return "usagesCount";
                }
            })(Data_Eq.eqNumber))()({
                reflectSymbol: function () {
                    return "unitConsumptionRate";
                }
            })(Data_Eq.eqNumber))()({
                reflectSymbol: function () {
                    return "unit";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                reflectSymbol: function () {
                    return "taxPercentage";
                }
            })(Types_Unit.eqTaxrate))()({
                reflectSymbol: function () {
                    return "sortingNumber";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                reflectSymbol: function () {
                    return "resourceClassificationGroup";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                reflectSymbol: function () {
                    return "projectId";
                }
            })(Data_Nullable.eqNullable(Types_Project.eqProjectId)))()({
                reflectSymbol: function () {
                    return "priceWithDiscount";
                }
            })(Data_Eq.eqNumber))()({
                reflectSymbol: function () {
                    return "pricePerUnit";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqNumber)))()({
                reflectSymbol: function () {
                    return "orgResourcePriceListId";
                }
            })(Data_Nullable.eqNullable(Types_Component.eqOrgEstimationResourceId)))()({
                reflectSymbol: function () {
                    return "orgResourcePriceId";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqInt)))()({
                reflectSymbol: function () {
                    return "name";
                }
            })(Data_Eq.eqString))()({
                reflectSymbol: function () {
                    return "multiplier";
                }
            })(Data_Eq.eqNumber))()({
                reflectSymbol: function () {
                    return "isCostClassPrice";
                }
            })(Data_Eq.eqBoolean))()({
                reflectSymbol: function () {
                    return "index";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqNumber)))()({
                reflectSymbol: function () {
                    return "id";
                }
            })(Types_Component.eqEstimationResourceId))()({
                reflectSymbol: function () {
                    return "group";
                }
            })(Data_Nullable.eqNullable(Types_ClassificationGroup.eqClassificationGroupCode)))()({
                reflectSymbol: function () {
                    return "estimationComponentId";
                }
            })(Data_Nullable.eqNullable(Types_Component.eqComponentId)))()({
                reflectSymbol: function () {
                    return "eanCode";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                reflectSymbol: function () {
                    return "discountPercentage";
                }
            })(Data_Eq.eqNumber))()({
                reflectSymbol: function () {
                    return "discountGroupCode";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                reflectSymbol: function () {
                    return "currencyId";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                reflectSymbol: function () {
                    return "costClassCode";
                }
            })(Data_Nullable.eqNullable(Types_Newtypes.eqCostClassCode)))()({
                reflectSymbol: function () {
                    return "contract";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                reflectSymbol: function () {
                    return "changeDate";
                }
            })(Data_Nullable.eqNullable(Data_Eq.eqString)))))(x.resources)(y.resources);
        };
    }
};
var ordWasmResourcesByComponent = {
    compare: function (x) {
        return function (y) {
            var v = (function () {
                var v1 = Data_Ord.compare(Data_Ord.ordNumber)(x.component.amount)(y.component.amount);
                if (v1 instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v1 instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                var v2 = Data_Ord.compare(Data_Ord.ordBoolean)(x.component.checked)(y.component.checked);
                if (v2 instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v2 instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                var v3 = Data_Ord.compare(Data_Nullable.ordNullable(Data_Ord.ordString))(x.component.classCode)(y.component.classCode);
                if (v3 instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v3 instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                var v4 = Data_Ord.compare(Data_Nullable.ordNullable(Data_Ord.ordString))(x.component.code)(y.component.code);
                if (v4 instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v4 instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                var v5 = Data_Ord.compare(Data_Ord.ordInt)(x.component.componentType)(y.component.componentType);
                if (v5 instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v5 instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                var v6 = Data_Ord.compare(Data_Nullable.ordNullable(Data_Ord.ordString))(x.component.costGroupCode)(y.component.costGroupCode);
                if (v6 instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v6 instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                var v7 = Data_Ord.compare(Data_Nullable.ordNullable(Data_Ord.ordString))(x.component.costGroupDescription)(y.component.costGroupDescription);
                if (v7 instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v7 instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                var v8 = Data_Ord.compare(Data_Ord.ordString)(x.component.description)(y.component.description);
                if (v8 instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v8 instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                var v9 = Data_Ord.compare(Data_Ord.ordBoolean)(x.component.flagged)(y.component.flagged);
                if (v9 instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v9 instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                var v10 = Data_Ord.compare(Data_Nullable.ordNullable(Types_ClassificationGroup.ordClassificationGroupCode))(x.component.group)(y.component.group);
                if (v10 instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v10 instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                var v11 = Data_Ord.compare(Types_Component.ordComponentId)(x.component.id)(y.component.id);
                if (v11 instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v11 instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                var v12 = Data_Ord.compare(Data_Ord.ordString)(x.component.memo)(y.component.memo);
                if (v12 instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v12 instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                var v13 = Data_Ord.compare(Data_Nullable.ordNullable(Data_Ord.ordString))(x.component.subProjectCode)(y.component.subProjectCode);
                if (v13 instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v13 instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                var v14 = Data_Ord.compare(Data_Nullable.ordNullable(Types_Project.ordSubprojectId))(x.component.subProjectId)(y.component.subProjectId);
                if (v14 instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v14 instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                var v15 = Data_Ord.compare(Data_Nullable.ordNullable(Data_Ord.ordString))(x.component.subProjectName)(y.component.subProjectName);
                if (v15 instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v15 instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                return Data_Ord.compare(Data_Nullable.ordNullable(Data_Ord.ordString))(x.component.unit)(y.component.unit);
            })();
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return Data_Ord.compare(Data_Ord.ordArray(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()({
                reflectSymbol: function () {
                    return "wastePercentage";
                }
            })(Data_Ord.ordNumber))()({
                reflectSymbol: function () {
                    return "vendorUnit";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordString)))()({
                reflectSymbol: function () {
                    return "vendorCode";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordString)))()({
                reflectSymbol: function () {
                    return "vendorBatchSize";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordNumber)))()({
                reflectSymbol: function () {
                    return "vendor";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordString)))()({
                reflectSymbol: function () {
                    return "validDate";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordString)))()({
                reflectSymbol: function () {
                    return "usagesCount";
                }
            })(Data_Ord.ordNumber))()({
                reflectSymbol: function () {
                    return "unitConsumptionRate";
                }
            })(Data_Ord.ordNumber))()({
                reflectSymbol: function () {
                    return "unit";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordString)))()({
                reflectSymbol: function () {
                    return "taxPercentage";
                }
            })(Types_Unit.ordTaxrate))()({
                reflectSymbol: function () {
                    return "sortingNumber";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordString)))()({
                reflectSymbol: function () {
                    return "resourceClassificationGroup";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordString)))()({
                reflectSymbol: function () {
                    return "projectId";
                }
            })(Data_Nullable.ordNullable(Types_Project.ordProjectId)))()({
                reflectSymbol: function () {
                    return "priceWithDiscount";
                }
            })(Data_Ord.ordNumber))()({
                reflectSymbol: function () {
                    return "pricePerUnit";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordNumber)))()({
                reflectSymbol: function () {
                    return "orgResourcePriceListId";
                }
            })(Data_Nullable.ordNullable(Types_Component.ordOrgEstimationResourceId)))()({
                reflectSymbol: function () {
                    return "orgResourcePriceId";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordInt)))()({
                reflectSymbol: function () {
                    return "name";
                }
            })(Data_Ord.ordString))()({
                reflectSymbol: function () {
                    return "multiplier";
                }
            })(Data_Ord.ordNumber))()({
                reflectSymbol: function () {
                    return "isCostClassPrice";
                }
            })(Data_Ord.ordBoolean))()({
                reflectSymbol: function () {
                    return "index";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordNumber)))()({
                reflectSymbol: function () {
                    return "id";
                }
            })(Types_Component.ordEstimationResourceId))()({
                reflectSymbol: function () {
                    return "group";
                }
            })(Data_Nullable.ordNullable(Types_ClassificationGroup.ordClassificationGroupCode)))()({
                reflectSymbol: function () {
                    return "estimationComponentId";
                }
            })(Data_Nullable.ordNullable(Types_Component.ordComponentId)))()({
                reflectSymbol: function () {
                    return "eanCode";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordString)))()({
                reflectSymbol: function () {
                    return "discountPercentage";
                }
            })(Data_Ord.ordNumber))()({
                reflectSymbol: function () {
                    return "discountGroupCode";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordString)))()({
                reflectSymbol: function () {
                    return "currencyId";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordString)))()({
                reflectSymbol: function () {
                    return "costClassCode";
                }
            })(Data_Nullable.ordNullable(Types_Newtypes.ordCostClassCode)))()({
                reflectSymbol: function () {
                    return "contract";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordString)))()({
                reflectSymbol: function () {
                    return "changeDate";
                }
            })(Data_Nullable.ordNullable(Data_Ord.ordString)))))(x.resources)(y.resources);
        };
    },
    Eq0: function () {
        return eqWasmResourcesByComponent;
    }
};
var eqECGroupByProperty = {
    eq: function (x) {
        return function (y) {
            if (x instanceof GroupBySubproject && y instanceof GroupBySubproject) {
                return true;
            };
            if (x instanceof GroupByGroup && y instanceof GroupByGroup) {
                return true;
            };
            if (x instanceof GroupByCostGroup && y instanceof GroupByCostGroup) {
                return true;
            };
            if (x instanceof GroupByClassification && y instanceof GroupByClassification) {
                return true;
            };
            if (x instanceof GroupByLocation && y instanceof GroupByLocation) {
                return true;
            };
            return false;
        };
    }
};
var eqClipboardComponents = {
    eq: function (x) {
        return function (y) {
            if (x instanceof ClipboardEmpty && y instanceof ClipboardEmpty) {
                return true;
            };
            if (x instanceof ClipboardComponentView && y instanceof ClipboardComponentView) {
                return Data_Eq.eq(Data_Eq.eqArray(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
                    reflectSymbol: function () {
                        return "unit";
                    }
                })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                    reflectSymbol: function () {
                        return "subProjectName";
                    }
                })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                    reflectSymbol: function () {
                        return "subProjectId";
                    }
                })(Data_Nullable.eqNullable(Types_Project.eqSubprojectId)))()({
                    reflectSymbol: function () {
                        return "subProjectCode";
                    }
                })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                    reflectSymbol: function () {
                        return "memo";
                    }
                })(Data_Eq.eqString))()({
                    reflectSymbol: function () {
                        return "id";
                    }
                })(Types_Component.eqComponentId))()({
                    reflectSymbol: function () {
                        return "group";
                    }
                })(Data_Nullable.eqNullable(Types_ClassificationGroup.eqClassificationGroupCode)))()({
                    reflectSymbol: function () {
                        return "flagged";
                    }
                })(Data_Eq.eqBoolean))()({
                    reflectSymbol: function () {
                        return "description";
                    }
                })(Data_Eq.eqString))()({
                    reflectSymbol: function () {
                        return "costGroupDescription";
                    }
                })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                    reflectSymbol: function () {
                        return "costGroupCode";
                    }
                })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                    reflectSymbol: function () {
                        return "componentType";
                    }
                })(Data_Eq.eqInt))()({
                    reflectSymbol: function () {
                        return "code";
                    }
                })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                    reflectSymbol: function () {
                        return "classCode";
                    }
                })(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
                    reflectSymbol: function () {
                        return "checked";
                    }
                })(Data_Eq.eqBoolean))()({
                    reflectSymbol: function () {
                        return "amount";
                    }
                })(Data_Eq.eqNumber))))(x.value0)(y.value0);
            };
            if (x instanceof ClipboardElementView && y instanceof ClipboardElementView) {
                return Data_Eq.eq(Types_Element.eqElementId)(x.value0.elementId)(y.value0.elementId) && Data_Eq.eq(Data_Eq.eqArray(Types_Element.eqWasmElementSpec))(x.value0.elementSpecs)(y.value0.elementSpecs);
            };
            return false;
        };
    }
};
module.exports = {
    GroupBySubproject: GroupBySubproject,
    GroupByGroup: GroupByGroup,
    GroupByCostGroup: GroupByCostGroup,
    GroupByClassification: GroupByClassification,
    GroupByLocation: GroupByLocation,
    ClipboardEmpty: ClipboardEmpty,
    ClipboardComponentView: ClipboardComponentView,
    ClipboardElementView: ClipboardElementView,
    WasmResourcesByComponent: WasmResourcesByComponent,
    eqECGroupByProperty: eqECGroupByProperty,
    eqClipboardComponents: eqClipboardComponents,
    newtypeWasmResourcesByComponent: newtypeWasmResourcesByComponent,
    ordWasmResourcesByComponent: ordWasmResourcesByComponent,
    eqWasmResourcesByComponent: eqWasmResourcesByComponent,
    jsonWasmResourcesByComponent: jsonWasmResourcesByComponent,
    genericECGroupByProperty: genericECGroupByProperty,
    tofuJSONECGroupByProperty: tofuJSONECGroupByProperty
};
